import { memo } from "react";
import { usePatchNotes } from "../hooks/usePatchNotes";
import { PatchNotesModal } from "./PatchNotesModal";

export const PatchNotesGate = memo(function PatchNotesGate() {
  const { open, notes, hasMore, close } = usePatchNotes();

  if (notes.length === 0) return null;

  return (
    <PatchNotesModal
      open={open}
      notes={notes}
      hasMore={hasMore}
      onClose={close}
    />
  );
});
